<template>
 	<b-container v-if="$can('view-customers') || $can('view-all')" fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Customers</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button variant="outline-primary" size="sm" @click="openModal('create-customer')">New Customer</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('receive-payment')">Receive Payment</b-button>
                        <!-- <b-button variant="outline-primary" size="sm" @click="openModal('apply-credit')">Apply Credit</b-button> -->
                        <b-button variant="outline-primary" size="sm" @click="openModal('export-columns')">Export</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('adjust-columns')"><i class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.customers.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.customers.filter" @click="tables.customers.filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col class="text-center" cols="3">
                        <b-button v-if="tables.customers.hasQueryClicks" variant="danger" size="sm" @click="clearQueryClicks">Clear Filters</b-button>
                    </b-col>

                    <b-col cols="5" />

                    <b-col cols="1">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.customers.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.customers.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-customers-table">
                    <b-container fluid>
                        <b-table
                            v-if="tables.customers.ready"
                            :key="tables.customers.key"
                            class="customers-table"
                            responsive bordered striped
                            hover no-border-collapse
                            sticky-header="calc(100vh - 250px)"
                            head-variant="light"
                            :items="tables.customers.items"
                            :fields="visibleFields"
                            :sort-by="tables.customers.sortBy"
                            :sort-desc="tables.customers.sortDesc"
                            :per-page="tables.customers.perPage"
                            :current-page="tables.customers.currentPage"
                            :filter="tables.customers.filter"
                            @filtered="onFiltered"
                            :busy="tables.customers.isBusy"
                        >

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(name)="row">
                                <b-link :ref="'customersTableRow' + row.item.id" @click="saveState('customersTableRow' + row.item.id)" :to="{name: 'CustomerDetail', params: {id: row.item.id}}">{{ row.item.name }}</b-link>
                            </template>

                            <template v-slot:cell(sales_rep_id)="row">
                                <span v-if="row.item.sales_rep">{{ row.item.sales_rep.name }}</span>
                            </template>

                            <template v-slot:cell(balance)="row">
                                <span>$ {{ numberWithCommas(row.item.balance) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(email)="row">
                                <span v-if="row.item.email"><b-link @click="openModal('create-email', row.item)">{{ row.item.email }}</b-link></span>
                            </template>

                            <template v-slot:cell(last_ordered)="row">
                                <span v-if="row.item.last_ordered"><b-link @click="openModal('show-last-invoice', row.item.last_ordered, row.item.name)">{{ row.item.last_ordered.date }}</b-link></span>
                            </template>

                            <template v-slot:cell(ratings_id)="row">
                                <span v-if="row.item.ratings_id">{{ row.item.rating.name }}</span>
                            </template>

                            <template v-slot:cell(billing_city)="row">
                                <span v-if="row.item.billing_city"><b-link @click="saveQueryClick('city', row.item)">{{ row.item.billing_city }}</b-link></span>
                            </template>

                            <template v-slot:cell(billing_state)="row">
                                <span v-if="row.item.billing_state"><b-link @click="saveQueryClick('state', row.item)">{{ row.item.billing_state }}</b-link></span>
                            </template>

                            <template v-slot:cell(billing_postal_code)="row">
                                <span v-if="row.item.billing_postal_code"><b-link @click="saveQueryClick('zip', row.item)">{{ row.item.billing_postal_code }}</b-link></span>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <!-- <b-col>
                                            <b-link @click=""><i class="far fa-check-square"></i></b-link>
                                        </b-col> -->
                                        <b-col v-if="row.item.name != 'META ERP'">
                                            <b-link @click="openModal('edit-customer', row.item)"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <b-col v-if="$can('view-all') && row.item.name != 'META ERP'">
                                            <b-link @click="" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.customers.currentPage"
                          :total-rows="tables.customers.totalRows"
                          :per-page="tables.customers.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-create-email
            v-if="modals['create-email'].active"
            :email="modals['create-email'].email"
        />

        <modal-create-customer
            v-if="modals['create-customer'].active"
        />

        <modal-receive-payment
            v-if="modals['receive-payment'].active"
        />

        <modal-apply-credit
            v-if="modals['apply-credit'].active"
        />

        <modal-show-last-invoice
            v-if="modals['show-last-invoice'].active"
            :row="modals['show-last-invoice'].row"
            :name="modals['show-last-invoice'].name"
        />

        <modal-edit-customer
            v-if="modals['edit-customer'].active"
            :row="modals['edit-customer'].row"
            @getRow="getCustomers"
        />

        <modal-adjust-columns
            v-if="modals['adjust-columns'].active"
            :fields="modals['adjust-columns'].fields"
            @saveColSaves="saveColSaves"
        />

        <modal-export-columns
            v-if="modals['export-columns'].active"
            :fields="modals['export-columns'].fields"
            :ignores="modals['export-columns'].ignores"
            @exportExcel="exportExcel"
        />
    </b-container>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ModalCreateEmail from './modals/CreateEmail'
    import ModalCreateCustomer from './modals/CreateCustomer'
    import ModalReceivePayment from './modals/ReceivePayment'
    import ModalApplyCredit from './modals/ApplyCredit'
    import ModalShowLastInvoice from './modals/ShowLastInvoice'
    import ModalEditCustomer from './modals/EditCustomer'
    import ModalAdjustColumns from '../../common/modals/AdjustColumns'
    import ModalExportColumns from '../../common/modals/ExportColumns'
    import { mapMutations } from 'vuex'
 	export default {
    	name: 'customers',

        metaInfo() {
            return {
                title: 'Customers',
            }
        },

    	components: {
              Treeselect,
              'modal-create-email': ModalCreateEmail,
              'modal-create-customer': ModalCreateCustomer,
              'modal-receive-payment': ModalReceivePayment,
              'modal-apply-credit': ModalApplyCredit,
              'modal-show-last-invoice': ModalShowLastInvoice,
              'modal-edit-customer': ModalEditCustomer,
              'modal-adjust-columns': ModalAdjustColumns,
              'modal-export-columns': ModalExportColumns
    	},
        data() {
            return {
                modals: {
                    'create-email': {
                        active: 0,
                        email: ''
                    },

                    'create-customer': {
                        active: 0
                    },

                    'receive-payment': {
                        active: 0
                    },

                    'apply-credit': {
                        active: 0
                    },

                    'show-last-invoice': {
                        row: [],
                        active: 0
                    },

                    'edit-customer': {
                        active: 0
                    },

                    'adjust-columns': {
                        active: 0,
                        fields: []
                    },

                    'export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['actions']
                    },
                },
                tables: {
                    customers: {
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500],
                        sortBy: 'date_completed',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        filterCat: '',
                        key: 1,
                        userfields: [],
                        fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'name',
                                label: 'Name',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'buyers_name',
                                label: 'Buyer Name',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'phone',
                                label: 'Phone',
                                thClass: 'customers-table-style-phone',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'email',
                                label: 'E-mail',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'balance',
                                label: 'Balance',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'last_ordered',
                                label: 'Last Ordered',
                                thClass: 'customers-table-style-th-datetime',
                                tdClass: 'customers-table-style-td-datetime',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'sales_rep_id',
                                label: 'Sales Rep',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'billing_city',
                                label: 'City',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'billing_state',
                                label: 'State',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'billing_postal_code',
                                label: 'Zip',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'ratings_id',
                                label: 'Customer Rating',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'customers-table-style-actions',
                                visible: 1
                            }
                        ],

                        items: [],
                        queryClicks: {
                            city: '',
                            state: '',
                            zip: ''
                        },
                        hasQueryClicks: false,
                        ready: 0
                    },
                },

                exports: {
                    cols: []
                }
            }
        },
        methods: {
            exportExcel(cols, keys) {
                let url = 'api/exports/generateexport'
                axios.post(url, {
                    rows: this.objFilter(this.tables.customers.filteredItems, keys),
                    table: 'customers',
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Customers_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Sales Orders export file generated successfully!')
            },

            saveState(name) {
                let page = this.tables.customers.currentPage
                let filter = this.tables.customers.filter
                let perPage = this.tables.customers.perPage
                this.setRememberCustomer({name: name, page: page, filter: filter, perPage: perPage })
            },

            saveQueryClick(field, row) {
                if (field == 'city') {
                    this.tables.customers.queryClicks['state'] = row.billing_state
                    this.tables.customers.queryClicks['city'] = row.billing_city
                }

                if (field == 'state') {
                    this.tables.customers.queryClicks['state'] = row.billing_state
                }

                if (field == 'zip') {
                    this.tables.customers.queryClicks['zip'] = row.billing_postal_code
                }

                this.getCustomers()
                this.tables.customers.hasQueryClicks = true
            },

            clearQueryClicks() {
                this.tables.customers.queryClicks['city'] = ''
                this.tables.customers.queryClicks['state'] = ''
                this.tables.customers.queryClicks['zip'] = ''
                this.tables.customers.hasQueryClicks = false
                this.getCustomers()
            },

            openModal(modalName, row, extra) {
                let prefix = 'modal-lists-customers-'
                switch (modalName) {
                    case 'create-customer':
                        this.modals[modalName].active = 1

                        break
                    case 'receive-payment':
                        this.modals[modalName].active = 1

                        break
                    case 'apply-credit':
                        this.modals[modalName].active = 1

                        break
                    case 'create-email':
                        this.modals[modalName].active = 1
                        this.modals[modalName].email = Object.assign({}, row.email)

                        break
                    case 'show-last-invoice':
                        this.modals[modalName].active = 1
                        this.modals[modalName].row = Object.assign({}, row)
                        this.modals[modalName].name = extra

                        break
                    case 'edit-customer':
                        this.modals[modalName].active = 1
                        this.modals[modalName].row = Object.assign({}, row)
                        break
                    case 'adjust-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = this.tables.customers.userFields ? JSON.parse(JSON.stringify(this.tables.customers.userFields)) : JSON.parse(JSON.stringify(this.tables.customers.fields))

                        break
                    case 'export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.customers.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break
                }

                if (modalName == 'adjust-columns' || modalName == 'export-columns') {
                    prefix = 'modal-common-'
                }

                this.$nextTick(() => {
                    this.$bvModal.show(prefix + modalName)
                })
            },

            toggleBusy() {
                this.tables.customers.isBusy = !this.tables.customers.isBusy
            },

            getCustomers(silent) {
                this.tables.customers.ready = 0
                this.tables.customers.filter = this.rememberedCustomer.filter
                this.tables.customers.perPage = this.rememberedCustomer.perPage

                if (!silent) {
                    this.toggleBusy()
                }

                let qClicks = this.tables.customers.queryClicks
                let url = 'api/lists/customers/getcustomers'
                axios.post(url, {
                    queryClicks: qClicks
                })
                .then((res) => {
                    this.tables.customers.items = res.data.customers
                    if (!this.tables.customers.filteredItems.length) {
                        this.tables.customers.filteredItems = res.data.customers
                    }
                    this.tables.customers.totalRows = this.tables.customers.items.length
                    this.tables.customers.ready = 1

                    if (!silent) {
                        this.toggleBusy()
                    }

                    this.setLastState()
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.customers.totalRows = filteredItems.length
                this.tables.customers.currentPage = 1
                this.tables.customers.filteredItems = filteredItems
            },

            setLastState() {
                this.$nextTick(() => {
                    if (this.rememberedCustomer.name && this.rememberedCustomer.page) {
                        this.tables.customers.currentPage = this.rememberedCustomer.page
                        this.$nextTick(() => {
                            this.$refs[this.rememberedCustomer.name].$el.scrollIntoView()
                        })
                    }
                })
            },

            // ...mapMutations({
            //     setRemember: 'remembered/SET_CUSTOMER'

            // }),

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/customers'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            if (res.data.colSaves.column_array.length == this.tables.customers.fields.length) {
                                this.tables.customers.userFields = res.data.colSaves.column_array
                            }
                        }

                        this.getCustomers()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                this.tables.customers.userFields = fields
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'customers',
                    fields: fields.map(e => ({key:e.key, visible:parseInt(e.visible), label:e.label}))
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.customers.ready = 0
                let tempFields = this.tables.customers.fields
                this.tables.customers.fields = []
                this.$nextTick(() => {
                    this.tables.customers.fields = tempFields
                    this.tables.customers.ready = 1
                })
            }
        },

    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.customers.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.customers.totalRows
                let currentPage = this.tables.customers.currentPage
                let perPage = this.tables.customers.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.customers.totalRows + ' rows'
            },

            visibleFields() {
                let userFields = this.tables.customers.userFields
                if (userFields) {
                    let fields = this.tables.customers.fields

                    return fields.filter(field => {
                        let index = this.findIndex(userFields, 'key', field.key)
                        if (userFields[index].visible) {
                            return true
                        }
                    })
                } else {
                    return this.tables.customers.fields
                }
            }
	    },

	    mounted() {
            this.getColSaves()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-lists-customers-create-email':
                        this.modals['create-email'].active = 0

                        break
                    case 'modal-lists-customers-create-customer':
                        this.modals['create-email'].active = 0

                        break
                    case 'modal-lists-customers-receive-payment':
                        this.modals['receive-payment'].active = 0

                        break
                    case 'modal-lists-customers-apply-credit':
                        this.modals['apply-credit'].active = 0

                        break
                    case 'modal-lists-customers-show-last-invoice':
                        this.modals['show-last-invoice'].active = 0

                        break
                    case 'modal-lists-customers-edit-customer':
                        this.modals['edit-customer'].active = 0

                        break
                    case 'modal-common-adjust-columns':
                        this.modals['adjust-columns'].active = 0
                        this.modals['adjust-columns'].fields = []

                        break
                    case 'modal-common-export-columns':
                        this.modals['export-columns'].active = 0
                        this.modals['export-columns'].fields = []

                        break
                }
            })

            // pusher
            Echo.channel('table-customer-updated')
                .listen('TableCustomerUpdated', (e) => {
                    this.getCustomers(1)
            })
	    }
  }
</script>
<style lang="scss">
    .vue-treeselect__control {
        // height: calc(1.5em + 0.5rem + 2px);
        // padding-top: 0.25rem;
        // padding-bottom: 0.25rem;
        // padding-left: 0.5rem;
        font-size: 0.875rem !important;

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            // line-height: 1.5
        }
    }

    .customers-table {
        height: 75vh;
        font-size: 9pt;

        .customers-table-style-actions {
            min-width: 120px;

            .actions-icons {
                text-align: center;
                white-space: nowrap;
            }
        }

        .customers-table-style-phone {
            min-width: 105px;
        }

        .customers-table-style-th-datetime {
            min-width: 110px;
        }

        .customers-table-style-td-datetime {
            text-align: center;
        }
    }
</style>
